import React from 'react';

import { type ButtonBaseProps } from '../ButtonBase';

import { type Size, Sizes } from './types';

import { StyledButtonText } from './styles';

type ButtonTextProps = Omit<ButtonBaseProps, 'color' | 'variant'> & {
    children: React.ReactNode;
    size?: Size;
};

export const ButtonText = ({ children, size = Sizes.medium, ...props }: ButtonTextProps) => (
    <StyledButtonText $size={size} {...props} color="transparent" variant="solid">
        {children}
    </StyledButtonText>
);
